<template>
  <div class="no-container">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/home">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>404</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <!-- //404页面 -->
    <div class="no-page" ref='page'>
      <div class="page-center">
        <img src="@/assets/image/homeImg/wifi.png" alt="">
        <div class="page-content">
            <p class="page-title">
              <span>页面飘走了，</span>
              <span class="shuaxin" @click="refersh()">刷新</span><span>试试看</span>
            </p>
            <!-- <div class="page-out"> 
            <p class="page-reason">可能原因：</p>
            <ul>
                <li>1. 网络信号差</li>
                <li>2. 找不到请求的页面</li>
                <li>3. 输入的网址不正确</li>
            </ul>
             <p class="page-reason" style="margin-top:30px">可以尝试：</p>
             <p class="back">
                 <router-link to='/home'>
                返回首页
                 </router-link>
             </p> -->
        <!-- </div> -->
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      onLine: navigator.onLine,
    }
  },
  methods:{
    refersh(){
      this.$router.push('/home')
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === 'online';
    },

  },
  mounted(){
    let height= window.screen.availHeight
    this.$refs.page.style.height = (height-260)+ 'px'
    //   window.addEventListener('online',  this.updateOnlineStatus);
    // window.addEventListener('offline', this.updateOnlineStatus);
    // window.addEventListener('online',  function(){
    //   alert("onLine");
    // });
    // window.addEventListener('offline', function(){
    //   alert("offLine");
    // });
  },
  beforeDestroy(){
    window.removeEventListener('online',  this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  }
}
</script>
<style lang="scss" scoped>
body{
  height: 100%;
}
.no-container{
  height: 100%;
}
.no-page{
  height: calc(100%-100px);
  position: relative;
  // min-height: 660px;
  background:#fff;
  .page-center{
    position: absolute;
    width: 430px;
    text-align: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    .page-title,.page-reason{
      font-size:18px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1)
    }
    .shuaxin{
      color: #4c84ff;
      cursor: pointer;
    }
    ul,li{
      font-size:14px;
      list-style: none;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(163,163,163,1);
    }
    .page-out{
      // width: 100px;
      margin-left:180px;
      margin-top: 38px;
      text-align: left;
      // margin: 0 auto;
    }
  }
}
</style>